import { ROUTE_DASHBOARD_BOOKING_PAGE } from '@/constants/routes';
import EventSummary from '@/types/EventSummary';
import { Box, ButtonGroup, IconButton, Link, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiEdit, FiLink } from 'react-icons/fi';
import { Link as RRLink, useHistory } from 'react-router-dom';

export interface IBookingPageItemProps {
	bookingPage: EventSummary;
	link: string;
	onCopyLinkClick: () => void;
}

export default function BookingPageItem(props: IBookingPageItemProps) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Box bg="white" borderWidth={1} borderColor="gray.200" borderRadius="md" px={4} pl={5} my={1} py={3}>
			<Box display="grid" gridTemplateColumns="1fr 1fr" gridTemplateRows="1fr">
				<Box display="grid" alignItems="center">
					<Link as={RRLink} to={props.link} flex="1" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
						{props.bookingPage.name || props.bookingPage.id}
					</Link>
				</Box>

				<Box display="flex" justifyContent="flex-end">
					<ButtonGroup isAttached variant="outline">
						<Tooltip label={t('Edit')}>
							<IconButton
								onClick={() => {
									history.push(ROUTE_DASHBOARD_BOOKING_PAGE.replace(':id', props.bookingPage.id));
								}}
								aria-label={t('Edit')}
								icon={<FiEdit />}
							/>
						</Tooltip>

						<Tooltip label={t('Copy link')}>
							<IconButton
								onClick={() => {
									props.onCopyLinkClick();
								}}
								aria-label={t('Copy link')}
								icon={<FiLink />}
							/>
						</Tooltip>
					</ButtonGroup>
				</Box>
			</Box>
		</Box>
	);
}
